import { isNewProject } from "@/preferences";
import VueRouter from "vue-router";

const oldOrderRouterName = [
  "estimates",
  "invoice",
  "purchase",
  "estimate-edit",
  "invoice-edit",
  "purchase-edit",
  "estimate-purchase",
  "report"
];

const newOrderRouterName = [
  "order-estimates",
  "order-invoice",
  "order-purchase",
  "order-estimate-edit",
  "order-invoice-edit",
  "order-purchase-edit",
  "order-estimate-purchase",
  "order-sale-report"
];

// If it's an old project that moves to the new order screen (possibly by changing the URL in the search bar...),
// then redirect to the not-found page (404),
// similar to the case of a new project moving to the old order screen.
export async function checkRedirectToOrderScreen(
  createDate: Date,
  router: VueRouter,
  routerName: string | undefined
) {
  if (
    routerName === undefined ||
    oldOrderRouterName.includes(routerName) ||
    newOrderRouterName.includes(routerName)
  ) {
    if (
      routerName === undefined ||
      (isNewProject(createDate) && oldOrderRouterName.includes(routerName)) ||
      (!isNewProject(createDate) && newOrderRouterName.includes(routerName))
    ) {
      await router.push({
        name: "not-found-page"
      });
    }
  }
}
